import React from "react";

export const ProcessFileMessage = ({ message = "Processing file..." } : Readonly<{ message?: string }>) => (
    <div className="d-flex flex-fill justify-content-center align-items-center py-4">
        <p className="m-0">{message}</p>
    </div>
);